import React, { forwardRef } from 'react';

const Textarea = forwardRef((props, ref) => {
  
  const handleChange = (event) => {
    const newValue = event.target.value;
    
    if (newValue.trim() === '') {
      event.target.value = '';
      props.onChange(event);
    } else {
      props.onChange(event);
    }
  };

  return (
        <textarea
            {...props}  // Spread all remaining props
            onChange={handleChange}
            ref={ref}
            data-id={props.dataId}
        />
    );
});

export default Textarea;



// WEBPACK FOOTER //
// ./src/components/Textarea/index.js